export default __webpack_public_path__ + "static/04-b659beedb3af4ec24aac1c2eeca5ebe4.jpg";